import React from "react";
import Logo from "./logo.png";

const ClickHandler = () => {
  window.scrollTo(10, 0);
};

const Footer = () => {
  const proposalsEmail = "support@jmccontractinggroup.com";

  // Optional: prefill subject/body
  const subject = encodeURIComponent("Proposal Request");
  const body = encodeURIComponent(
    "Hi JMC Contracting Group,\n\nI’d like to request a proposal/estimate.\n\nProject Location:\nType of Work:\nDesired Start Date:\nBest Contact Name/Phone:\n\nAdditional Details:\n"
  );

  const mailtoHref = `mailto:${proposalsEmail}?subject=${subject}&body=${body}`;

  return (
    <footer className="wpo-site-footer">
      <div className="container">
        <div className="wpo-footer-inner">
          <div className="footer-logo">
            <img src={Logo} alt="JMC Contracting Group LLC logo" />
          </div>

          <nav className="footer-menu">
            <a href="/" onClick={ClickHandler}>
              Home
            </a>
            <a href="/service" onClick={ClickHandler}>
              Services
            </a>
  
          </nav>

          <div className="col-lg-12 text-center estimate-bar">
            <a className="footer-cta" href={mailtoHref}>
              Email Proposals: {proposalsEmail}
            </a>
          </div>
        </div>

        <div className="wpo-lower-footer">
          © 2026 JMC Contracting Group LLC — All Rights Reserved
        </div>
      </div>
    </footer>
  );
};

export default Footer;